/**
 * Which API errors are the user's choice rather than a failure (access tiers,
 * FRS FR44): a cancelled sign-in prompt (`error.handled`), or a 401 that asks
 * for sign-in. Its own module so the ErrorBoundary — in the main bundle — can
 * ask without importing the axios client.
 */
export const PROMPT_CODES = new Set(["auth_required", "token_expired", "invalid_token"]);

export const isHandledAuthError = (error) =>
  Boolean(error?.handled) ||
  (error?.response?.status === 401 && PROMPT_CODES.has(error.response.data?.code));
